import isArray from 'lodash/isArray'
import { ISchedule, IKeyValueType } from '@/types/schedules'
import { formatDate } from './date'
import { decodeName } from './nameValidation'

const RECURRENCE: IKeyValueType = {
  OnlyOnce: 'Only Once',
  Weekly: 'Weekly',
  Monthly: 'Monthly',
  Daily: 'Daily',
}

const IN_PROGRESS_STATUS = 'IN PROGRESS'

export const STATUS: IKeyValueType = {
  FAILED: {
    variation: 'error',
    text: 'schedule.status.failed',
  },
  'IN PROGRESS': {
    variation: 'informational',
    text: 'schedule.status.inProgress',
  },
  SUCCESS: {
    variation: 'success',
    text: 'schedule.status.success',
  },
  'NOT-STARTED': {
    variation: 'informational',
    text: 'schedule.status.notStarted',
  },
}

export const scheduleMapper = (schedules: ISchedule[]) => {
  if (!isArray(schedules)) {
    return []
  }

  return schedules.map((record) => ({
    id: record.id,
    name: decodeName(record.name),
    status:
      record.status && record.status !== IN_PROGRESS_STATUS
        ? STATUS[record.status]
        : STATUS['NOT-STARTED'],
    lastRun:
      record.status === IN_PROGRESS_STATUS
        ? formatDate('NA')
        : formatDate(record.last_run_time),
    nextRun: formatDate(record.next_run_time),
    recurrence: RECURRENCE[record.frequency?.repeatType],
    startDay: record.start_day,
    frequency: record.frequency,
    runningTime: record.running_time,
    feedName: record.feed_name,
    feedId: record.feed_id,
    sourceType: record.source_type,
  }))
}
